// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsible-container.dark {
  background-color: #f4f2ea;
}
.collapsible-container .collapsible-heading-container {
  position: relative;
}
.collapsible-container .collapsible-heading-container .arrow {
  background-image: url('closed-chev-big.847c1b52d4b4a306.svg');
  width: 24px;
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
  transform: rotate(180deg);
}
.collapsible-container .collapsible-heading-container .arrow:hover {
  cursor: pointer;
}
.collapsible-container .collapsible-content-container {
  max-height: 100%;
  position: relative;
}
.collapsible-container .collapsible-content-container .scroll-top {
  position: absolute;
  right: -2px;
  bottom: -25px;
  transform: rotate(-90deg);
  width: 52px;
  height: 52px;
  background-image: url('filled-chev-up.11c94d73d6cc8e53.svg');
}
.collapsible-container .collapsible-content-container .scroll-top:hover {
  cursor: pointer;
}
.collapsible-container.collapsed .collapsible-heading-container .arrow {
  transform: none;
}
.collapsible-container.collapsed .collapsible-content-container {
  overflow: hidden;
  max-height: 0;
}
.collapsible-container.collapsed .scroll-top {
  display: none;
}
.collapsible-container .arrow {
  outline: 0;
  text-shadow: none;
}
.collapsible-container .arrow:hover,
.collapsible-container .arrow:focus,
.collapsible-container .arrow:active {
  outline: 1px solid;
  outline: auto -webkit-focus-ring-color;
  outline-color: #b39841;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/collapsible-panel/collapsible-panel.component.less"],"names":[],"mappings":"AAIE;EACE,yBAAA;AAHJ;AAAA;EAOQ,kBAAA;AAJR;AAHA;EAUY,6DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;AAJZ;AAMY;EACI,eAAA;AAJhB;AAfA;EAyBQ,gBAAA;EACA,kBAAA;AAPR;AAnBA;EA6BY,kBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,4DAAA;AAPZ;AASY;EACI,eAAA;AAPhB;AAYI;EAGY,eAAA;AAZhB;AASI;EAQQ,gBAAA;EACA,aAAA;AAdZ;AAKI;EAaQ,aAAA;AAfZ;AAzCA;EA6DQ,UAAA;EACA,iBAAA;AAjBR;AA7CA;;;EAoEQ,kBAAA;EACA,sCAAA;EACA,sBAAA;AAlBR","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.collapsible-container {\n\n  &.dark {\n    background-color: @primary-40;\n  }\n\n    .collapsible-heading-container {\n        position: relative;\n\n        .arrow {\n            background-image: url('../../styles/img/closed-chev-big.svg');\n            width: 24px;\n            height: 24px;\n            position: absolute;\n            top: 0;\n            right: 0;\n            transform: rotate(180deg);\n\n            &:hover {\n                cursor: pointer;\n            }\n        }\n    }\n\n    .collapsible-content-container {\n        max-height: 100%;\n        position: relative;\n\n        .scroll-top {\n            position: absolute;\n            right: -2px;\n            bottom: -25px;\n            transform: rotate(-90deg);\n            width: 52px;\n            height: 52px;\n            background-image: url(\"../../styles/img/filled-chev-up.svg\");\n\n            &:hover {\n                cursor: pointer;\n            }\n        }\n    }\n\n    &.collapsed {\n        .collapsible-heading-container {\n            .arrow {\n                transform: none;\n            }\n        }\n\n        .collapsible-content-container {\n            overflow: hidden;\n            max-height: 0;\n        }\n\n        .scroll-top {\n            display: none;\n        }\n    }\n\n    .arrow {\n        outline: 0;\n        text-shadow: none;\n    }\n\n    .arrow:hover,\n    .arrow:focus,\n    .arrow:active {\n        outline: 1px solid;\n        outline: auto -webkit-focus-ring-color;\n        outline-color: @primary-90;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
